import { List } from 'immutable';
import { PayCategoryFactory } from '@/domain/payCategories/adapters';
import { PAY_CATEGORY_SYSTEM_TYPE_FIELD, PAY_CATEGORY_SYSTEM_TYPES } from '@/domain/payCategories/constants';

// transforms flat list to nested list
export const createTreeFromNestedSet = (arr) =>
  arr
    .filter(({ visible }) => visible)
    .sort((a, b) => a.order - b.order || a.left - b.left)
    .reduce(
      (tree, n) => {
        let curr = null;
        let nextIndex = null;
        let next = tree;
        const updatePath = ['children'];
        const parentList = [];

        while (next) {
          curr = next;
          next = curr.children.find((c) => c.left < n.left && c.right > n.right);
          if (next) {
            nextIndex = curr.children.findIndex((c) => c.left < n.left && c.right > n.right);
            updatePath.push(nextIndex, 'children');
            if (next.id !== null && next.id !== undefined) {
              parentList.push(next.id);
            }
          }
        }
        // the only affected field we calculate and update for category record
        const updatedRecord = n.set('parentList', List(parentList));
        return tree.updateIn(updatePath, (list) => list.push(updatedRecord));
      },
      PayCategoryFactory({ children: List() }),
    ).children;

export const getRootItems = (list) =>
  list.filter((item) => item.parentId === 1 && item.visible).sort((a, b) => a.order - b.order || a.left - b.left);

export const getNestedCategory = ({ category1, category2 }) => category2 || category1;

export const getSystemType = (category) => category.get(PAY_CATEGORY_SYSTEM_TYPE_FIELD);

export const isSystemType = (category, type) => getSystemType(category) === type;

export const findCatBySystemType = (categories, type) => categories.find((cat) => isSystemType(cat, type));

export const findCatById = (categories, id) => categories.find((cat) => String(cat.id) === String(id));

export const isCategoryAll = (category) => (category ? isSystemType(category, PAY_CATEGORY_SYSTEM_TYPES.all) : false);

export const isToApproveCategory = (category) =>
  category ? isSystemType(category, PAY_CATEGORY_SYSTEM_TYPES.to_approve) : false;

export const isPaymentProcessCategory = (category) =>
  category ? isSystemType(category, PAY_CATEGORY_SYSTEM_TYPES.payment_process) : false;

export const getCategoryAll = (categories) => findCatBySystemType(categories, PAY_CATEGORY_SYSTEM_TYPES.all);
